module.exports = __webpack_public_path__ + "media/loket.54bb5ddd.wav";